<template>
    <a-card ref="FreeEvaluationDetail">
        <a-form-model class="search-form" layout="inline" :model="searchForm">
            <a-form-model-item label="渠道名称">
                <a-input :maxLength="11" allowClear v-model="searchForm.name" placeholder="请输入渠道名称"/>
            </a-form-model-item>
            <a-form-model-item style="margin-right: 35px;">
                <a-button @click="getPageList(1)" type="primary" html-type="button">
                    查询
                </a-button>
                <a-button @click="searchReset" style="margin-left: 10px;">
                    重置
                </a-button>
            </a-form-model-item>
        </a-form-model>
        <div style="overflow: auto;">
            <a-table style="min-width: 800px;"
                     :columns="columns"
                     :rowKey="(text, index) => text.id + '' + index"
                     :pagination="tableRelevant.tablePagination"
                     :loading="tableRelevant.tableLoading"
                     :dataSource="tableRelevant.tableDataSource">
                <div slot="status" slot-scope="text" v-auth="`FreeEvaluationChannel.Status`">
                    <a-switch checkedChildren="启用" unCheckedChildren="禁用" v-model="text.enabled"
                              @change="status(text)"/>
                </div>
                <div slot="action" slot-scope="text" class="action">
                    <a v-if="text.enabled" v-permission="`FreeEvaluationChannel.CopyUrl`" @click="copyUrl(text)"
                       href="javaScript:;">复制链接</a>
                    <span v-else v-permission="`FreeEvaluationChannel.CopyUrl`">复制链接</span>
                    <a v-if="text.enabled" v-permission="`FreeEvaluationChannel.DownCode`" @click="downCode(text)"
                       href="javaScript:;">下载二维码</a>
                    <span v-else v-permission="`FreeEvaluationChannel.DownCode`">下载二维码</span>
                </div>
            </a-table>
        </div>
    </a-card>
</template>

<script>
    import {tableRelevant} from "@/pages/projectImpl/js/utils";
    import $Bus from "@/pages/projectImpl/js/eventBus";

    const columns = [
        {
            title: '渠道名称',
            dataIndex: 'name'
        },
        {
            title: '状态',
            scopedSlots: {customRender: 'status'}
        },
        {
            title: '操作',
            width: 250,
            scopedSlots: {customRender: 'action'}
        }
    ];
    export default {
        name: "FreeEvaluationChannel",
        data() {
            return {
                columns,
                searchForm: {
                    name: undefined
                },
                //表格相关
                tableRelevant: tableRelevant.call(this),
            }
        },
        mounted() {
            $Bus.$emit("pageHeaderTitle", this.$route.query.name);
            const breadcrumb = [
                "首页",
                "运营中心",
                this.$route.query.type === "1" ? {name: "体验课配置", path: "/operate/ExperienceCourse"}
                    : {name: "免费测评", path: "/operate/FreeEvaluation"},
                "渠道链接"
            ];
            $Bus.$emit("pageHeaderBreadcrumb", breadcrumb);

            this.getPageList(1);
        },
        methods: {
            getPageList(pageIndex) {
                const params = {
                    groupId: this.$route.query.id,
                    pageIndex: pageIndex || this.tableRelevant.tablePagination.current,
                    pageSize: this.tableRelevant.tablePagination.pageSize,
                    ...this.searchForm
                };
                this.tableRelevant.tableLoading = true;
                this.$http.Channel.getGroupChannelPageList(params).then(res => {
                    this.tableRelevant.tableLoading = false;
                    const {data} = res.data;
                    this.tableRelevant.tableDataSource = data.items;
                    this.tableRelevant.tablePagination.total = data.totalCount;
                    this.tableRelevant.tablePagination.current = data.pageIndex;
                })
            },

            //重置
            searchReset() {
                for (let key in this.searchForm) {
                    this.searchForm[key] = undefined;
                }
                this.getPageList(1);
            },

            status(val) {
                const form = new FormData();
                form.append("groupId", this.$route.query.id);
                form.append("channelId", val.channelId);
                this.tableRelevant.tableLoading = true;
                this.$http.Channel.updateChannelStatus(form).then(res => {
                    this.tableRelevant.tableLoading = false;
                    const {message} = res.data;
                    this.$message.success(message);
                    this.getPageList();
                })
            },

            copyUrl(val) {
                this.$message.destroy();
                try {
                    if (window.clipboardData) {
                        window.clipboardData.setData('text', val.url);
                    } else {
                        (function (s) {
                            document.oncopy = function (e) {
                                e.clipboardData.setData('text', s);
                                e.preventDefault();
                                document.oncopy = null;
                            }
                        })(val.url);
                        document.execCommand('Copy');
                    }
                    this.$message.success("复制成功");
                } catch (e) {
                    this.$message.error("复制失败，请手动复制🐕！");
                }
            },
            downCode(val) {
                const a = document.createElement('a');
                a.href = process.env.VUE_APP_API_BASE_URL
                    + "/2c/coursecenter/CourseGroupChannel/GetGroupChannelQR?groupChannelId="
                    + val.groupChannelId;
                a.download = val.name;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
            }
        }
    }
</script>

<style scoped>

</style>